import { render, staticRenderFns } from "./HospitalRecruitersList.vue?vue&type=template&id=78756c0a&scoped=true"
import script from "./HospitalRecruitersList.vue?vue&type=script&lang=js"
export * from "./HospitalRecruitersList.vue?vue&type=script&lang=js"
import style0 from "./HospitalRecruitersList.vue?vue&type=style&index=0&id=78756c0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78756c0a",
  null
  
)

export default component.exports